import { create } from 'zustand';

interface MenuState {
  isMainMenuOpen: boolean;
  isCategoryMenuOpen: boolean;
  isLanguageMenuOpen: boolean;
  /** Chat panel open (desktop side panel / phone sheet) and, on phones, expanded to ~45vh. */
  isChatOpen: boolean;
  isChatExpanded: boolean;
  setChatOpen: (open: boolean) => void;
  setChatExpanded: (expanded: boolean) => void;
  toggleMainMenu: () => void;
  toggleCategoryMenu: () => void;
  toggleLanguageMenu: () => void;
  closeAllMenus: () => void;
}

export const useMenuStore = create<MenuState>((set) => ({
  isMainMenuOpen: false,
  isCategoryMenuOpen: false,
  isLanguageMenuOpen: false,
  isChatOpen: false,
  isChatExpanded: false,
  setChatOpen: (open) => set({ isChatOpen: open, isChatExpanded: open }),
  setChatExpanded: (expanded) => set({ isChatExpanded: expanded }),
  toggleMainMenu: () => set((state) => ({ isMainMenuOpen: !state.isMainMenuOpen })),
  toggleCategoryMenu: () => set((state) => ({ isCategoryMenuOpen: !state.isCategoryMenuOpen })),
  toggleLanguageMenu: () => set((state) => ({ isLanguageMenuOpen: !state.isLanguageMenuOpen })),
  closeAllMenus: () => set({
    isMainMenuOpen: false,
    isCategoryMenuOpen: false,
    isLanguageMenuOpen: false,
  }),
}));

